export const VIDEO_MODE = 'normal';

export const PLAY_STORE = {
  citizen: 'https://play.google.com/store/apps/details?id=com.loksy_citizen&hl=en_IN',
  mitra: 'https://play.google.com/store/apps/details?id=com.loksy.mitra&hl=en_IN',
  lms: 'https://play.google.com/store/apps/details?id=com.knls.academy&hl=en_IN',
};

export const WEB_LOGIN = {
  citizen: '/user-login',
  mitra: '/locsydashboard',
  lms: '/student/login',
};

export const loksyVideos = {
  citizen: {
    id: 'citizen',
    title: 'Loksy Citizen',
    shortTitle: 'Citizen',
    tagline: 'Local services for you.',
    ariaLabel: 'Loksy Citizen app demonstration',
    playStore: PLAY_STORE.citizen,
    webTo: WEB_LOGIN.citizen,
    webLabel: 'Open Citizen website',
    playLabel: 'Get Citizen on Play',
    loginTo: '/user-login',
    mp4: '/videos/loksy-citizen.mp4',
    webm: '/videos/loksy-citizen.webm',
    fallbackMp4: '/videos/citizen-demo.mp4',
    poster: '/images/citizen-poster.webp',
    posterFallback: '/images/citizen-poster.png',
    chapters: [
      { time: 0, title: 'Discover', description: 'Find local shops around you.' },
      { time: 5, title: 'Search', description: 'Ask for what your town has.' },
      { time: 10, title: 'Nearby shops', description: 'Kirana, food, health, services.' },
      { time: 16, title: 'The shop', description: 'Photos, products, hours, pay.' },
      { time: 22, title: 'Local jobs', description: 'See opportunities near your town.' },
      { time: 28, title: 'Coupons', description: 'Offers from shops you already know.' },
      { time: 34, title: 'QR / UPI', description: 'Pay at the counter, from the phone.' },
    ],
  },
  mitra: {
    id: 'mitra',
    title: 'Loksy Vyapar',
    shortTitle: 'Vyapar',
    tagline: 'Run the shop. Grow the shop.',
    ariaLabel: 'Loksy Vyapar app demonstration',
    playStore: PLAY_STORE.mitra,
    webTo: WEB_LOGIN.mitra,
    webLabel: 'Open Vyapar website',
    playLabel: 'Get Vyapar on Play',
    loginTo: '/locsydashboard',
    mp4: '/videos/loksy-mitra.mp4',
    webm: '/videos/loksy-mitra.webm',
    fallbackMp4: '/videos/mitra-demo.mp4',
    poster: '/images/mitra-poster.webp',
    posterFallback: '/images/mitra-poster.png',
    chapters: [
      { time: 0, title: 'One login', description: 'Operate inside. Grow outside.' },
      { time: 6, title: 'Smart bill', description: 'GST, cart, cash, card, UPI.' },
      { time: 14, title: 'Collect', description: 'Close the sale at the counter.' },
      { time: 20, title: 'Leads', description: 'Call, WhatsApp, convert.' },
      { time: 26, title: 'Attendance', description: 'Mark present from the floor.' },
      { time: 32, title: 'Reports', description: 'See the day without a PC.' },
      { time: 40, title: 'Publish', description: 'Photos, products, coupons, ads.' },
    ],
  },
  operation: {
    id: 'operation',
    title: 'Phone Operation',
    shortTitle: 'Phone',
    tagline: 'The counter fits in a hand.',
    ariaLabel: 'Loksy phone operation demonstration',
    playStore: PLAY_STORE.mitra,
    webTo: WEB_LOGIN.mitra,
    webLabel: 'Open Vyapar website',
    playLabel: 'Get Vyapar on Play',
    loginTo: '/locsydashboard',
    mp4: '/videos/phone-operation.mp4',
    webm: '/videos/phone-operation.webm',
    fallbackMp4: '/videos/operation-demo.mp4',
    poster: '/images/operation-poster.webp',
    posterFallback: '/images/operation-poster.png',
    chapters: [
      { time: 0, title: 'Smart Bill', description: 'Thumb-first billing.' },
      { time: 7, title: 'Add product', description: 'Scan or search. Add to cart.' },
      { time: 14, title: 'Payment', description: 'UPI, cash, card, wallet.' },
      { time: 20, title: 'Leads', description: 'Follow up without leaving the app.' },
      { time: 26, title: 'Attendance', description: 'Students, staff, the shop floor.' },
      { time: 32, title: 'Reports', description: 'The day, in your pocket.' },
      { time: 38, title: 'Voice search', description: 'Open any tool by speaking.' },
    ],
  },
  lms: {
    id: 'lms',
    title: 'Students LMS',
    shortTitle: 'LMS',
    tagline: 'Learn to earn.',
    ariaLabel: 'Students LMS app demonstration',
    playStore: PLAY_STORE.lms,
    webTo: WEB_LOGIN.lms,
    webLabel: 'Open student website',
    playLabel: 'Get LMS on Play',
    loginTo: '/student/login',
    mp4: '/videos/students-lms.mp4',
    webm: '/videos/students-lms.webm',
    fallbackMp4: '/videos/lms-demo.mp4',
    poster: '/images/lms-poster.webp',
    posterFallback: '/images/lms-poster.png',
    chapters: [
      { time: 0, title: 'My courses', description: 'What you are learning now.' },
      { time: 6, title: 'A course', description: 'Chapters in a clear path.' },
      { time: 12, title: 'Watch', description: 'Lessons that play on the phone.' },
      { time: 18, title: 'Read', description: 'Learn to earn — build your career.' },
      { time: 24, title: 'Flashcards', description: 'Remember what matters.' },
      { time: 30, title: 'Typing', description: 'Speed and accuracy, tracked.' },
      { time: 36, title: 'Progress', description: 'See how far you have come.' },
    ],
  },
  overview: {
    id: 'overview',
    title: 'Loksy',
    shortTitle: 'Loksy',
    tagline: 'Your Town. Just One Click Away.',
    ariaLabel: 'Loksy ecosystem overview',
    playStore: PLAY_STORE.citizen,
    webTo: '/portals',
    webLabel: 'Open website login',
    playLabel: 'Get Citizen on Play',
    loginTo: '/portals',
    mp4: '/videos/loksy-overview.mp4',
    webm: '/videos/loksy-overview.webm',
    fallbackMp4: '/videos/overview-demo.mp4',
    poster: '/images/overview-poster.webp',
    posterFallback: '/images/overview-poster.png',
    chapters: [
      { time: 0, title: 'Citizen', description: 'The town, in a pocket.' },
      { time: 6, title: 'The shop', description: 'What the street can see.' },
      { time: 12, title: 'Vyapar', description: 'One login for the counter.' },
      { time: 18, title: 'Billing', description: 'The sale, on the phone.' },
      { time: 24, title: 'Leads', description: 'Work that waits, then converts.' },
      { time: 30, title: 'Attendance', description: 'Present, from the floor.' },
      { time: 36, title: 'Learn', description: 'The classroom in the same town.' },
      { time: 42, title: 'Town', description: 'Four faces. One town.' },
    ],
  },
};

export const productSelector = ['citizen', 'mitra', 'lms'];

export function productsForBrand(brand) {
  if (brand === 'knls') return ['lms'];
  if (brand === 'loksy') return ['citizen', 'mitra'];
  return productSelector;
}

export function formatTimecode(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return '00:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function chapterAt(chapters, time) {
  let current = chapters[0];
  for (const chapter of chapters) {
    if (time >= chapter.time) current = chapter;
  }
  return current;
}
